import React, { Component } from 'react';

class Tracker {
  constructor() {
    this.lastPushed = null;
  }
  getLast() {
    return this.lastPushed;
  }
  setLast(x) {
    this.lastPushed = x;
  }
}

const tr = new Tracker();

class MetaLoader extends Component {
  componentWillReceiveProps(nextProps) {
    const { title: b } = nextProps;
    const lastPushed = tr.getLast();
    if (lastPushed === b) return;
    if (!b) return;
    const { dataLayer } = window || {};
    const payload = {
      event: 'pageTitleUpdated',
      pageTitle: b
    };
    dataLayer.push(payload);
    tr.setLast(b);
  }
  render() {
    return false;
  }
}

export default MetaLoader;
